import { Button } from "antd";

export const ActionButton = ({
  title,
  action,
  style
}: {
  title: string;
  action: () => void;
  style?: React.CSSProperties;
}) => {
  return (
    <div>
      <Button
        onClick={(e) => {
          e.preventDefault();
          action();
        }}
        style={{
          paddingLeft: "20px",
          paddingRight: "20px",
          backgroundColor: "#F4EFFF",
          borderRadius: "20px",
          border: "1px transparent",
          color: "black",
          fontWeight: "normal",
          marginBottom: "-30px",
          zIndex: 50,
          ...style
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.fontWeight = "500";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.fontWeight = "normal";
        }}
      >
        {title}
      </Button>
    </div>
  );
};
